// StoreProvider.tsx

import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode
} from "react";
import type { JamEvent } from "./jam";

type StoreState = {
  loaded: true,
  selected?: JamEvent,
  jams: JamEvent[],
  lookup: Record<string, number>,
} | { loaded: false };

type StoreContextValue = {
  store: StoreState,
  setStore: React.Dispatch<React.SetStateAction<StoreState>>,
  selectJam: (id: string) => void
};

const StoreContext = createContext<StoreContextValue | undefined>(undefined);

export function StoreProvider({
  children
}: {
    children: ReactNode;
  }) {
  const [store, setStore] = useState<StoreState>({ loaded: false });

  const selectJam = (id: string) => {
    if (!store.loaded) return;
    const index = store.lookup[id];
    if (index === undefined) return;

    const jam = store.jams[index];
    if (jam) setStore({ ...store, selected: jam });
  };


  useEffect(() => {
    fetch('/jams.json')
      .then(response => response.json())
      .then(json => {
        const lookup: Record<string, number> = {};
        const jams = json as JamEvent[];
        jams.map((jam, index) => {
          lookup[jam.id] = index;
        })


        setStore({
          loaded: true,
          jams: json as JamEvent[],
          lookup,
        })
      });
  }, []);

  return (
    <StoreContext.Provider
      value={{ store, setStore, selectJam }}
    >
      {children}
    </StoreContext.Provider>
  );
}

export function useStore() {
  const context = useContext(StoreContext);

  if (!context) {
    throw new Error(
      "useStore must be used within StoreProvider"
    );
  }

  return context;
}
